import { render } from "./IconEdit.vue?vue&type=template&id=17235bae"
import script from "./IconEdit.vue?vue&type=script&lang=js"
export * from "./IconEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__